import * as React from "react";
import "./welcomeOverlayStyles.css";
import { getStvVersionNumber } from "../../../utils/LoadShaka";
export var WelcomeOverlay = function () {
    var engineVersion = getStvVersionNumber();
    return (React.createElement("div", { id: "app-loader", className: "app-loader" },
        React.createElement("div", { className: "app-loader-content" },
            React.createElement("div", { className: "app-loader-logo" }),
            React.createElement("p", { className: "loading-text" }, "\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D1\u10D0, \u10D2\u10D7\u10EE\u10DD\u10D5\u10D7 \u10D3\u10D0\u10D4\u10DA\u10DD\u10D3\u10DD\u10D7"),
            React.createElement("p", { className: "version" },
                "Version: ",
                window.CAVEA_PLUS_STB_VERSION || ""),
            engineVersion ? (React.createElement("p", { className: "engine-version" },
                "Engine: ",
                engineVersion)) : null)));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/welcome-overlay/WelcomeOverlay.tsx
// module id = 146
// module chunks = 1